import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=14b9fff6&scoped=true&"
import script from "./Loader.vue?vue&type=script&lang=js&"
export * from "./Loader.vue?vue&type=script&lang=js&"
import style0 from "./Loader.vue?vue&type=style&index=0&id=14b9fff6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../login/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b9fff6",
  null
  
)

export default component.exports